define('common/ko/fn/find',['knockout', 'underscore', 'common/tools'], function(ko, _, tools) {
    ko.subscribable.fn.find = _.memoize(function(findFn) {
        var self = this;
        findFn = findFn || function() { return false; };
        return ko.pureComputed(function() {
            return _.find(self(), findFn);
        }).extend({ rateLimit: 0 });
    }, function(findFn) { return tools.objToHash([this, findFn]); } );
});

